import React, { memo } from "react";
import Card from "./Card";
import "./ChefComponent.css";

const VerifiedChefComponent = memo(
  ({
    handleShowMenu,
    handleUnVerifyChef,
    handleChefStatus,
    handleProfileUpdate,
    handleChefImage,
    handleChefDesc,
    handleKitchenImages,
    handleEmiStatus,
    chefLevelData,
    handlePerformance,
    handleMenuCount,
    handleCraverNotifications,
    showActive,
    setShowActive
  }) => {
    const activeChefs = chefLevelData.filter((data) => data.isUserAvailable);
      const inactiveChefs = chefLevelData.filter((data) => !data.isUserAvailable);
    
      const handleChefNewMenu = (data) => {
        window.open(
          `/newChefMenu?chefID=${data.userID}&kitchenName=${data.userKitchen}&ChefName=${data.userName}&mobileNumber=${data.userMobile}`,
          "_blank"
        );
      };

    const renderCards = (dataList) => {
      return dataList.map((data) => (
        <Card
        type="Verified"
          key={data.userID}
          data={data}
          handleShowMenu={handleShowMenu}
          handleUnVerifyChef={handleUnVerifyChef}
          handleChefStatus={handleChefStatus}
          handleChefNewMenu={handleChefNewMenu}
          handleProfileUpdate={handleProfileUpdate}
          handleChefImage={handleChefImage}
          handleChefDesc={handleChefDesc}
          handleKitchenImages={handleKitchenImages}
          handleEmiStatus={handleEmiStatus}
          handlePerformance={handlePerformance}
          handleMenuCount={handleMenuCount}
          handleCraverNotifications={handleCraverNotifications}
        />
      ));
    };

    return (
      <>
      <div className="btn-group btn-group-sm" role="group" aria-label="Small button group">
            <button
              type="button"
              className={`btn ${showActive ? "btn-primary" : "btn-outline-dark"}`}
              onClick={() => setShowActive(true)}
            >
              Available Chefs - {activeChefs.length}
            </button>
            <button
              type="button"
              className={`btn ${!showActive ? "btn-primary" : "btn-outline-dark"}`}
              onClick={() => setShowActive(false)}
            >
              Unavailable Chefs - {inactiveChefs.length}
            </button>
          </div>
      <div className="rowDisplayCards">
      {showActive
              ? renderCards(activeChefs)
              : renderCards(inactiveChefs)
      }
      </div>
      </>
    );
  }
);

export default VerifiedChefComponent;
